import Chip from '$tablet-app/src/app/components/Chip';
import Row from '$tablet-app/src/app/components/Row';
import Tile from '$tablet-app/src/app/components/Tile';
import { hasImage } from '$tablet-app/src/app/images/actions';
import useRecordImage from '$tablet-app/src/app/images/hooks/useRecordImage';
import { recipe_tile_image_edits } from '$tablet-app/src/app/recipes/data/image_params';
import { Recipe } from '$tablet-app/src/app/recipes/types';
import { palette } from '$tablet-app/src/app/theme';
import { Text } from '@akin-home/text/native';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React, { FC } from 'react';
import { View } from 'react-native';
import styled from 'styled-components/native';

interface Props {
  /** The recipe to be displayed */
  recipe: Recipe;

  /** Whether the recipe is a favourite */
  isFavourite?: boolean;

  isChosen?: boolean;

  onSelectRecipe?: (recipe: Recipe) => void;
  onClickRecipe?: (recipe: Recipe) => void;
  onPressFavourite?: (recipeID: string) => void;
}

const RecipeSelectTile: FC<Props> = (props) => {
  const { recipe, onSelectRecipe, onClickRecipe, isChosen } = props;

  const onSelectHandler = () => onSelectRecipe && onSelectRecipe(recipe);

  const onClickSeeRecipeHandler = () => onClickRecipe && onClickRecipe(recipe);

  const { source } = useRecordImage({
    record: recipe,
    edits: recipe_tile_image_edits,
  });

  return (
    <RecipeTile chosen={isChosen}>
      <ClickableArea onPress={onSelectHandler}>
        {hasImage(recipe) ? (
          <RecipeImage source={source} />
        ) : (
          <PlaceholderImage>
            <PlaceholderIcon
              icon="salad"
              color={palette.primary_70}
              secondaryColor={palette.Secondary_blue}
              size={80}
            />
          </PlaceholderImage>
        )}

        <TopContent>
          {recipe.prepTime ? (
            <Chip iconLeft="clock" color="white">
              <Text variant="p2" weight="semibold">
                {recipe.prepTime.label}
              </Text>
            </Chip>
          ) : (
            <View />
          )}

          <TickIconWrapper>
            <FontAwesomeIcon
              size={20}
              icon="check-circle"
              color={isChosen ? '#535AF1' : 'lightgrey'}
            />
          </TickIconWrapper>
        </TopContent>

        <NameContainer>
          <Text weight="semibold">{recipe.name}</Text>
        </NameContainer>
      </ClickableArea>

      <Row>
        <ChosenButton onPress={onClickSeeRecipeHandler}>
          <ChosenText weight="semibold">See recipe</ChosenText>
        </ChosenButton>
      </Row>
    </RecipeTile>
  );
};

const RecipeTile = styled(Tile)<{ chosen?: boolean }>`
  width: 260px;
  overflow: hidden;
  flex-grow: 1;

  border: 1px solid ${({ chosen }) => (chosen ? `#535AF1;` : 'white')};
`;

const NameContainer = styled.View`
  flex-grow: 1;
  padding: 16px;
`;

const ChosenButton = styled.TouchableOpacity<{ chosen?: boolean }>`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border-top-width: 1px;
  border-top-color: #e6e8eb;
  flex-grow: 1;

  ${({ chosen }) => chosen && `background-color: rgba(47, 57, 238, 0.1)`}
`;

const ChosenText = styled(Text)`
  color: ${palette.primary_70};
`;

const ClickableArea = styled.TouchableOpacity`
  flex-grow: 1;
`;

const TopContent = styled.View`
  position: absolute;
  top: 8px;
  left: 8px;
  right: 8px;
  flex-direction: row;
  justify-content: space-between;
`;

const RecipeImage = styled.Image`
  padding: 16px;
  height: 180px;
`;

const PlaceholderImage = styled.View`
  padding: 16px;
  height: 180px;
  background-color: rgba(47, 57, 238, 0.1);
`;

const PlaceholderIcon = styled(FontAwesomeIcon)`
  position: absolute;
  top: 50px;
  left: 90px;
`;

const TickIconWrapper = styled.View`
  height: 41px;
  width: 41px;

  align-items: center;
  justify-content: center;

  background-color: white;

  border-radius: 10px;
`;

export default RecipeSelectTile;
